<template>

    <div class="LeftGather" ref="LeftGather">

        <!--活动入口-->
        <!-- <div class="active-enter-module iconfont icon-huodong" @click="" v-show="activeshow"></div>-->

    </div>


</template>

<script>
    export default {
        name: "LeftGather",

        computed:{
            activeshow(){
                let plugInSettings = this.$mapStore.plugInfo.plugInfo.plugInSettings;
                return !this.$mapStep.type && !this.$BRT.$urlParam.share.status && (plugInSettings.poiActivityOpen > 0 || plugInSettings.themeActivityOpen > 0);
            },
        }
    }
</script>

<style lang="less">

    @import "./../../../../styles/index";

    .LeftGather{
        .absoluteByCover();
        top: @standartHeightA4 + @standartSpaceA5;
        right: auto;
        bottom: auto;
        left: 0px;
        padding-left: @standartSpaceA5;

        @height:@standartHeightA4;
        @space:@standartSpaceA4;

        >.active-enter-module{
            width: @height;
            height: @height;
            line-height: @height;
            text-align: center;

            pointer-events: auto;

            margin-top: @space;

            border-radius: @height/2;

            background-color: @orangeColor;

            font-size: @fontSizeA2;
            color: @themeReverseColor;

            box-shadow: @shadowbox;

            &:active{
                opacity: .8;
            }

        }
    }
</style>
